import React, { useState } from 'react'
import { reduxForm, formValueSelector } from 'redux-form'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import * as actions from '../actions/TablaCamionesCaladosActions'
import { connect } from 'react-redux'
import EditIcon from '@material-ui/icons/Edit'
import UpdateIcon from '@material-ui/icons/Update'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import { Dialog } from '@material-ui/core'
import DialogView from '../../../../../Dialogos/DialogView'
import DialogoCaladoUpdate from '../components/DialogoCaladoUpdate'
import { toast } from 'react-toastify'
import { FORM_PROCESO_CALADO } from '../../../../../../config/forms'

const selector = formValueSelector(FORM_PROCESO_CALADO)

function EdicionCamionesCalados (props) {
  const { numero, roles, data } = props

  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)

  const handleClose = () => {
    setOpen(false)
    props.updateConsultaCea(null)
  }

  const handleSubmit = async () => {
    const {
      modoIngreso,
      condicion,
      puestoCalado,
      authperito,
      user
    } = props

    if ((modoIngreso !== 'A') && !condicion) {
      if (modoIngreso === 'C') {
        toast.error(`No esta seleccionada el tipo de condición.`)
      } else if (modoIngreso === 'R') {
        toast.error(`No esta seleccionado el motivo de rechazo.`)
      }
    } else {
      let dispositivoHuella
      let perito
      (puestoCalado === 'calle_1-2') ? dispositivoHuella = 'PERITOUD' : dispositivoHuella = 'PERITOTC'
      // Chequea si esta el parametro de autenticacoin por huella en TRUE
      if (authperito) {
        perito = await props.dialogHuella(dispositivoHuella)
      } else {
        perito = user
      }
      if (perito && perito !== undefined) {
        props.updateProceso(perito, props.destroy)
        handleClose()
      }
    }
  }

  function onClick () {
    handleOpen()
  }

  function rechazar (numero) {
    window.alert('Este procedimiento rechazará la CPE sólo en ARCA')
    const result = window.confirm('¿Desea RECHAZAR la CPE en ARCA?')
    if (result) props.rechazarEnAfip(numero)
  }

  function actualizar (numero) {
    const result = window.confirm('¿Desea actualizar la CPE desde ARCA?')
    if (result) props.actualizarDesdeAfip(numero)
  }

  const rol = roles.filter(roles => roles === 'SUPERVISOR' || roles === 'SUPMANTENIMIENTO' || roles === 'DESARROLLADOR' || roles === 'PLANILLERO')
  const rolAutorizado = (rol[0] === 'SUPERVISOR' || rol[0] === 'SUPMANTENIMIENTO' || rol[0] === 'DESARROLLADOR' || rol[0] === 'PLANILLERO')

  return (
    <div>
      {(rolAutorizado) && <div>
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth='xl'>
          <DialogView
            confirmCallback={handleSubmit}
            cancelCallback={handleClose}
            title='Edición calado'
            content={
              <DialogoCaladoUpdate numero={numero} />
            }
          />
        </Dialog>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Tooltip title={'Editar'}>
            <IconButton onClick={onClick}>
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={'Rechazar en ARCA'}>
            <IconButton onClick={() => rechazar(numero)} disabled={(data.rowData[0] === 'A')}>
              <HighlightOffIcon color={(data.rowData[0] === 'A') ? 'info' : 'error'} />
            </IconButton>
          </Tooltip>
          {(data.rowData[0] === 'A') &&
            <Tooltip title={'Actualizar desde ARCA'}>
              <IconButton onClick={() => actualizar(numero)}>
                <UpdateIcon color='primary' />
              </IconButton>
            </Tooltip>
          }
        </div>
      </div> }
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    cea: state.calado.consultaCea,
    condicion: selector(state, 'condicionIngreso'),
    modoIngreso: selector(state, 'modoIngreso') ? selector(state, 'modoIngreso') : 'A',
    puestoCalado: state.calado.consultaCea ? state.calado.consultaCea.puestoDeCalado : null,
    roles: state.auth.roles,
    user: state.auth.username,
    authperito: state.calado.authperito
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PROCESO_CALADO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(EdicionCamionesCalados))
